import React from "react";
import SubscriptionIcon from '../icons/SubscriptionIcon.png';
import PremiereIcon from '../icons/premiere.svg'
import { BASE_PATH } from "../constants/awsBaseUrl";
const toTry = [
  "out_003.png",
  "out_002.png",
  "out_001.png",
]

class Preview extends React.Component {
  state = {
    url: "/",
    _id: this.props.file,
    height: 110,
    failed: false,
    loaded: false,
    srcNumber: 0,
    customThumbnail:`${BASE_PATH}/outputs/${this.props.file}/Default/Thumbnails/out_003.png`
  };
  render() {
    let { srcNumber } = this.state
    let baseUrl = `${BASE_PATH}/outputs/${this.props.file}/Default/Thumbnails/${toTry[srcNumber]}`
    return (
     <div className="thumbnail">
        <img
          className='thumbnail-img'
          style={
            this.state.loaded
              ? { transitionDuration: ".25s",  filter: this.props.notAccessible||this.props.premiering ? 'brightness(0.3)' : null }
              : { display: "none", transitionDuration: ".25s" }
          }
          src={`${this.state.customThumbnail}?refresh=${new Date().getMonth()}${new Date().getDate()}${new Date().getFullYear()}`}
          onLoad={() => this.setState({ loaded: true, failed: false })}
          onError={(e) => {
            e.target.src = `${baseUrl}?refresh=${new Date().getMonth()}${new Date().getDate()}${new Date().getFullYear()}`
          }}
          alt="thumbnail"
          
        />
       
       {this.props.notAccessible &&  <img className="thumbnail-lock-icon" src={SubscriptionIcon} alt='subscription icon'  />}
       {this.props.premiereDate && <img className="thumbnail-lock-icon" src={PremiereIcon} alt='premiere video'  />}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            width: "100%",
            padding: "25%",
          }}
        >
          <i
            className="fas fa-spinner fa-2x "
            style={{ 
              color: this.props.color,
              visibility: this.state.failed || this.state.loaded ? 'hidden': ''
          }}
          ></i>
        </div>
      </div>
    );
  }
}
export default Preview;
